import withStyles from '@mui/styles/withStyles';
import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';
import {connect} from 'react-redux';

import {authOperations} from './../../../reducks/auth';
import {commonOperations} from './../../../reducks/common';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import NegativeButton from '../../atoms/Buttons/NegativeButton.js';
import {PositiveButton} from '../../atoms/Buttons/PositiveButton.js';
import withRouter from '../withRouter.js';

const styles = (theme) => ({
  root: {
    display: 'flex',
  },
  dialogcontext: {
    color: 'black',
    whiteSpace: 'pre-line',
  },
});

class CustomDialog extends React.Component {
  state = {
    runFlg: false,
    action: null,
    cancelFlg: false,
    cancelAction: null,
  };

  handleClose = (event) => {
    // Escでダイアログボックスを閉じることを禁止
    if (event.key === 'Escape') {
      return;
    }
    this.setState({runFlg: false});
    this.props.doCloseDialog();
  };

  handleRun = (event) => {
    this.setState({
      runFlg: true,
      cancelFlg: false,
      action: this.props.dialogInfo.action});
    this.props.doCloseDialog();
  };

  handleCancel = (event) => {
    this.setState({
      runFlg: false,
      cancelFlg: true,
      cancelAction: this.props.dialogInfo.cancelAction,
    });
    this.props.doCloseDialog();
  };

  handleError = (event) => {
    this.setState({runFlg: true, action: this.doLogin});
    this.props.doCloseDialog();
  };

  handleExited = (event) => {
    // ダイアログを表示した状態で、ブラウザバックなどの対処
    if (this.props.location.pathname !== this.props.dialogInfo.address) {
      this.props.doCloseDialog();
      return;
    }

    // OKボタン押下時、ボタン押下時の処理が設定されていれば実行
    if (this.state.runFlg && this.state.action) {
      this.state.action();
    }

    // キャンセルボタン押下時、ボタン押下時の処理が設定されていれば実行
    if (this.state.cancelFlg && this.state.cancelAction) {
      this.state.cancelAction();
    }
  };

  doLogin = () => {
    this.props.navigate('/login');
  };

  render() {
    const {dialogInfo, classes, location} = this.props;
    const messages = [];

    return (
      <div>
        <Dialog
          open={dialogInfo.open && (location.pathname === dialogInfo.address)}
          TransitionProps={{onExited: this.handleExited}}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              this.handleClose(event);
            }
          }}
          aria-labelledby="responsive-dialog-title"
          sx={{zIndex: '1501'}}
        >
          {dialogInfo.title &&
            <DialogTitle
              id="responsive-dialog-title"
              sx={{padding: '3pt 10pt', color: '#fff', backgroundColor: '#4F89C6'}}>
              <FormattedMessage id={dialogInfo.title}/>
            </DialogTitle>
          }
          <DialogContent dividers>
            <DialogContentText className={classes.dialogcontext}>
              {Array.isArray(dialogInfo.context) &&
                dialogInfo.context.forEach((context) => {
                  if (context.text) {
                    messages.push(context.text);
                  } else {
                    messages.push(
                        <>
                          <FormattedMessage
                            id={context.id}
                            values={context.values}
                          />
                          <br/>
                        </>);
                  }
                })
              }
              {messages.length > 0 && messages }
            </DialogContentText>
          </DialogContent>
          {(dialogInfo.type === 'ok') &&
          <DialogActions>
            <PositiveButton
              id="btnDialogOk"
              onClick={this.handleRun}
              variant="contained"
              size="middle"
            >
              <span>OK</span>
            </PositiveButton>
          </DialogActions>
          }
          {(dialogInfo.type === 'okcancel') &&
          <DialogActions>
            <PositiveButton
              id="btnDialogOk"
              onClick={this.handleRun}
              variant="contained"
              size="middle"
            >
              <span>OK</span>
            </PositiveButton>
            <NegativeButton
              id="btnDialogCancel"
              onClick={this.handleCancel}
              variant="contained"
              size="middle"
            >
              <span>キャンセル</span>
            </NegativeButton>
          </DialogActions>
          }
          {(dialogInfo.type === 'close') &&
          <DialogActions>
            <PositiveButton
              id="btnDialogOk"
              onClick={this.handleClose}
              variant="contained"
              size="middle"
            >
              <span>OK</span>
            </PositiveButton>
          </DialogActions>
          }
          {(dialogInfo.type === 'error') &&
          <DialogActions>
            <PositiveButton
              id="btnDialogOk"
              onClick={this.handleError}
              variant="contained"
              size="middle"
            >
              <span>OK</span>
            </PositiveButton>
          </DialogActions>
          }
        </Dialog>
      </div>
    );
  }
}

CustomDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  dialogInfo: PropTypes.object,
  doCloseDialog: PropTypes.func.isRequired,
  pathname: PropTypes.string,
  navigate: PropTypes.func,
  location: PropTypes.object,
};

const mapStateToProps = (state) => ({
  dialogInfo: state.common.dialogInfo,
  // pathname: state.router.location.pathname,
});

const mapDispatchToProps = {
  doCloseDialog: commonOperations.closeDialog,
  doLogout: authOperations.doLogoutOperation,
};

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(CustomDialog)),
);
